import { render, staticRenderFns } from "./TeamMemberSodEodReport.vue?vue&type=template&id=b35aeb84"
import script from "./TeamMemberSodEodReport.vue?vue&type=script&lang=js"
export * from "./TeamMemberSodEodReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports